import { apiPrivateAxios } from "../../axios";
import { IDocumentListItem, IServiceDocument } from "./types";

export const documentsRequest = {
  getPatientDocuments: (patientId: string): Promise<IDocumentListItem[]> =>
    apiPrivateAxios.get(`/patient-document/${patientId}`),

  getPatientEnrollmentDocuments: (
    patientId: string,
    enrollmentId: string
  ): Promise<IDocumentListItem[]> =>
    apiPrivateAxios.get(
      `/patient-document/${patientId}/enrollment/${enrollmentId}`
    ),

  uploadPatientDocument: (
    patientId: string,
    enrollmentId: string,
    data: FormData
  ): Promise<IDocumentListItem[]> =>
    apiPrivateAxios.post(
      `/patient-document/${patientId}/enrollment/${enrollmentId}`,
      data
    ),

  getPatientDocumentContent: (
    patientId: string,
    documentId: string,
    download = false
  ): Promise<Blob> =>
    apiPrivateAxios.get(
      `/patient-document/${patientId}/${documentId}/content`,
      { params: { download }, responseType: "blob" }
    ),

  deletePatientDocument: (
    patientId: string,
    documentId: string
  ): Promise<void> =>
    apiPrivateAxios.delete(`/patient-document/${patientId}/${documentId}`),

  getServiceDocuments: (serviceId: string): Promise<IServiceDocument[]> =>
    apiPrivateAxios.get(`/service-document/${serviceId}`),

  uploadServiceDocument: (
    serviceId: string,
    data: FormData
  ): Promise<IServiceDocument[]> =>
    apiPrivateAxios.post(`/service-document/${serviceId}`, data),

  getServiceDocumentContent: (
    serviceId: string,
    documentId: string,
    download = false
  ): Promise<Blob> =>
    apiPrivateAxios.get(
      `/service-document/${serviceId}/${documentId}/content`,
      { params: { download }, responseType: "blob" }
    ),

  deleteServiceDocument: (
    serviceId: string,
    documentId: string
  ): Promise<void> =>
    apiPrivateAxios.delete(`/service-document/${serviceId}/${documentId}`),
};

const documentsRequestModule = { documentsRequest };

export default documentsRequestModule;
